import { createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { LessonListVM } from "@shared-kernel/application/ports/admin/admin-repository";

export const retrievePaymentLessonList = createAsyncThunk<LessonListVM, string, { extra: Partial<Dependencies> }>(
  "transfers/retrievePaymentLessonList",
  async (id: string, { extra: { adminRepository } }) => {
    return adminRepository!.listTransferLessons(id);
  },
);
